import React from "react";
import CIcon from '@coreui/icons-react';
import { cibTelegram } from '@coreui/icons';

function HomePage() {
    return (
        <div className="max-w-2xl w-full bg-black bg-opacity-80 p-8 rounded-2xl shadow-2xl border border-gray-800 text-center">
            <div className="flex items-center justify-center mb-6">
                <img src="icon.png" alt="Star Cricket" className="h-16 w-16 mr-3" />
                <h1 className="text-4xl font-bold text-yellow-400">Star Cricket 🏏</h1>
            </div>

            <p className="text-xl text-white mb-6">Enjoy live streaming of your favorite cricket matches!</p>

            <div className="mt-8 flex flex-col gap-4">
                <a
                    href="https://telegram.me/star_ccricket"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 rounded-lg transition-colors font-bold"
                >
                    <CIcon icon={cibTelegram} size="lg" className="text-white w-8 h-8" />
                    <span className="text-lg">Join our Telegram Channel</span>
                </a>

                <div className="text-gray-400 text-sm">For match schedules, updates and special features</div>
            </div>
        </div>
    );
}

export default HomePage;
